import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { MenuPermissionKey } from './menu-permissions';

export const menuPermissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const permissao = route.data['permissaoMenu'] as MenuPermissionKey | undefined;

  if (!permissao || auth.canAccess(permissao)) return true;

  router.navigateByUrl(auth.firstAllowedPath());
  return false;
};
